export const isCanadaReport = (reportDetails) => {
  const countryCode = reportDetails?.device_location?.countryCode;
  return String(countryCode || "").toUpperCase() === "CA";
};
